<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="text-body-2 font-weight-bold text-black">
          {{ $t(title) }}
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pa-4 text-black">
        <v-form v-model="valid" ref="form">
          <span class="calculate">
            {{ `${formattedPrice} $ * ${inputValue} = ${formattedTotal} $` }}
          </span>
          <v-divider class="my-3"/>
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex justify-space-between align-center ga-1 w-50">
              <span class="quantity">{{ $t('Кол-во:') }}</span>
              <CountInput
                horizontal
                :precision="{min: 0, max: 2}"
                v-model="inputValue"
                @change="$emit('changed')"
                :max="position.quantity"
                :min="0.01"
                :rules="[].concat(validation.number(0.01, position.quantity, true, true, true))"
              />
            </div>
            <v-btn
              color="primary"
              class="text-body-2 font-weight-bold"
              variant="elevated"
              :disabled="!valid"
              @click.native="agree"
            >
              {{ $t(options.agreeText) }}
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import CountInput from "@/components/form/CountInput.vue";
import validation from "@/components/validation";
import { formatStartPrice } from "@/filters";

export default {
  name: 'QuantitySelectDlg',
  components: {CountInput},
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      inputValue: 0,
      title: null,
      position: {},
      valid: true,
      validation,
      formatStartPrice,
      options: {
        color: 'grey lighten-3',
        width: 500,
        zIndex: 200,
        noconfirm: false,
        required: false,
        placeholder: '',
        agreeText: 'Да',
        rules: [],
      },
    };
  },
  computed: {
    quantity() {
      return Number(this.inputValue || 0);
    },
    formattedPrice() {
      return this.formatStartPrice(Number(this.position.price || 0));
    },
    formattedTotal() {
      return this.formatStartPrice(Number(this.position.price || 0) * Number(this.inputValue || 0));
    },
  },
  methods: {
    open(title, position = {}, options = {}) {
      this.dialog = true;
      this.title = title;
      this.inputValue = Number(position.quantity || 0);
      this.position = position;
      this.options = Object.assign({}, this.options, options);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      if (this.$refs.form.validate()) {
        this.dialog = false;
        this.resolve({
          confirmed: true,
          value: this.inputValue,
        });
      }
    },
    cancel() {
      this.dialog = false;
      this.resolve({
        confirmed: false,
        value: null,
      });
    },
  },
};
</script>
<style scoped>
.calculate {
  font-weight: 500;
}

.quantity {
  color: rgb(var(--unactive-text-color));
  font-weight: 600;
}

:deep(.v-label::after) {
  content: ' *';
  color: rgba(var(--error-color));
}

:deep(.not-required .v-label::after) {
  content: '';
  color: transparent;
}

:deep(.v-expansion-panel-title) {
  font-weight: 500;
  font-size: 18px;
}

:deep(.v-expansion-panel-title--active) {
  background-color: rgb(var(--grey-lighten-color));
}

:deep(.v-expansion-panel-text) {
  font-size: 16px;
  font-weight: 400;
  padding-left: 10px;
  word-wrap: break-word;
  white-space: normal
}

:deep(.v-field--focused.v-field--variant-underlined .v-field__outline::after) {
  transform: scaleX(0);
}

:deep(.v-field.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 0.38;
}

@media (hover: hover) {
  :deep(.v-field:hover .v-field__outline) {
    --v-field-border-opacity: 0.38;
  }
}
</style>
